import type z from 'zod/v4'
import { index, integer, pgTable, text, timestamp, uuid } from 'drizzle-orm/pg-core'
import { createInsertSchema, createSelectSchema, createUpdateSchema } from 'drizzle-zod'

export const Curriculum = pgTable(
  'curriculum',
  {
    id: uuid().notNull().primaryKey(),
    name: text().notNull(),
    description: text(),
    iconUrl: text(),
    order: integer().notNull(),
    legacyCategoryId: integer(),
    legacyNeonTagId: uuid(),
    updatedAt: timestamp({ mode: 'date', withTimezone: true, precision: 3 }).notNull(),
    createdAt: timestamp({ mode: 'date', withTimezone: true, precision: 3 }).notNull(),
  },
  (columns) => [
    index('curriculum_name_idx').on(columns.name),
    index('curriculum_updated_at_idx').on(columns.updatedAt),
    index('curriculum_created_at_idx').on(columns.createdAt),
  ],
)

export const InsertCurriculumSchema = createInsertSchema(Curriculum)
export const UpdateCurriculumSchema = createUpdateSchema(Curriculum)
  .omit({ id: true, legacyCategoryId: true, legacyNeonTagId: true })
  .partial()
export const SelectCurriculumSchema = createSelectSchema(Curriculum)

export type InsertCurriculum = typeof Curriculum.$inferInsert
export type UpdateCurriculum = z.infer<typeof UpdateCurriculumSchema>
export type SelectCurriculum = typeof Curriculum.$inferSelect
